"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _ModalDialog = _interopRequireDefault(require("@jobmatchme/ui/es/components/ModalDialog"));

var _Pc = require("@jobmatchme/amplify-tools/es/provider/Pc");

var _Button = _interopRequireDefault(require("@jobmatchme/ui/es/components/styleguide/Button"));

var _PowerSettingsNew = _interopRequireDefault(require("@material-ui/icons/PowerSettingsNew"));

var _Headline = _interopRequireDefault(require("@jobmatchme/ui/es/components/Form/Headline"));

var _EditUser = _interopRequireDefault(require("@jobmatchme/ui/es/components/Form/EditUser"));

var _ChangePassword = _interopRequireDefault(require("@jobmatchme/ui/es/components/Form/ChangePassword"));

var _Edit = _interopRequireDefault(require("@jobmatchme/profile-components/es/components/Edit"));

var _trackingService = require("@jobmatchme/frontend-analytics/es/trackingService.js");

var _getConfig = _interopRequireDefault(require("@jobmatchme/profile-components/es/resources/getConfig"));

var _translatedPaths = _interopRequireDefault(require("@jobmatchme/landing-page-components/es/utils/translatedPaths.js"));

var _Flags = _interopRequireDefault(require("@jobmatchme/ui/es/components/styleguide/LanguageSelector/Flags"));

var _Authentication = require("../../provider/Authentication");

var _validators = require("@jobmatchme/ui/es/utils/validators");

var _FormControlLabel = _interopRequireDefault(require("@material-ui/core/FormControlLabel"));

var _Matches = require("../../provider/Matches");

var _Switcher = _interopRequireDefault(require("@jobmatchme/ui/es/components/Switcher"));

var _DeactivationQuestion = _interopRequireDefault(require("../DeactivationQuestion"));

var _AccountVerification = _interopRequireDefault(require("../AccountVerification"));

var _reactHookForm = require("react-hook-form");

var _VerticalChange = _interopRequireDefault(require("../VerticalChange"));

var _reactI18next = require("react-i18next");

var _Box = _interopRequireDefault(require("@material-ui/core/Box"));

var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));

var _notistack = require("notistack");

var _Profile = require("../../provider/Profile");

var _Vertical = require("../../provider/Vertical");

var _styleModule = _interopRequireDefault(require("./style.module.scss"));

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var translateNs = 'pc-matching:ProfileForm';

var ProfileForm = function ProfileForm(_ref) {
  var enqueueSnackbar = _ref.enqueueSnackbar;

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  var _useAmplifyUser = (0, _Pc.useAmplifyUser)(),
      user = _useAmplifyUser.user,
      isAuthenticated = _useAmplifyUser.isAuthenticated,
      fetchUserData = _useAmplifyUser.fetchUserData,
      loadAuth = _useAmplifyUser.loadAuth;

  var _useContext = (0, _react.useContext)(_Vertical.VerticalContext),
      vertical = _useContext.vertical;

  var profileConfig = (0, _getConfig.default)(vertical ? vertical : '')('pc');

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      openQuestionDialog = _useState2[0],
      setOpenQuestionDialog = _useState2[1];

  var actions = (0, _react.useContext)(_Authentication.AuthenticationActionsContext);
  var context = (0, _react.useContext)(_Profile.ProfileContext);

  var _useContext2 = (0, _react.useContext)(_Profile.ProfileActionsContext),
      updateProfile = _useContext2.updateProfile;

  var _useContext3 = (0, _react.useContext)(_Profile.ProfileStatusContext),
      loaded = _useContext3.loaded;

  var _useContext4 = (0, _react.useContext)(_Matches.MatchesActionsContext),
      fetchMatches = _useContext4.fetchMatches,
      executeWhileLoading = _useContext4.executeWhileLoading;

  var _useContext5 = (0, _react.useContext)(_Profile.ProfileActionsContext),
      updateProfileState = _useContext5.updateProfileState;

  var _useContext6 = (0, _react.useContext)(_Profile.ProfileActionsContext),
      fetchProfile = _useContext6.fetchProfile;

  var _useState3 = (0, _react.useState)(typeof context.active === 'undefined' ? true : context.active),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      profileState = _useState4[0],
      setProfileState = _useState4[1];

  var formMethods = (0, _reactHookForm.useForm)({
    mode: 'onBlur',
    reValidateMode: 'onBlur'
  });

  var _useState5 = (0, _react.useState)(false),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      showPasswordDefault = _useState6[0],
      setShowPasswordDefault = _useState6[1];

  var _useState7 = (0, _react.useState)((user === null || user === void 0 ? void 0 : user.attributes['custom:locale']) || 'de'),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      activeLang = _useState8[0],
      setActiveLang = _useState8[1];

  var _useState9 = (0, _react.useState)(false),
      _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
      langTouched = _useState10[0],
      setLangTouched = _useState10[1];

  var showQuestionByDeactivation = function showQuestionByDeactivation() {
    try {
      if (!localStorage.getItem('questionShowed')) {
        setOpenQuestionDialog(true);
        localStorage.setItem('questionShowed', 'true');
      }
    } catch (error) {
      return console.error('Error: ', error);
    }
  };

  var closeForm = function closeForm() {
    setOpenQuestionDialog(false);
  };

  var showMessage = (0, _react.useCallback)(function (severity, messageField, messageType) {
    enqueueSnackbar(t("".concat(translateNs, ".Validation.").concat(messageType, ".").concat(messageField)), {
      variant: severity,
      anchorOrigin: {
        vertical: 'top',
        horizontal: 'right'
      }
    });
  }, [enqueueSnackbar, t]);
  var onProfileUpdate = (0, _react.useCallback)(function (profile) {
    return executeWhileLoading([function () {
      return updateProfile(profile).then(function (updatedProfile) {
        showMessage('success', 'changes', 'Success');
        return updatedProfile;
      });
    }, fetchMatches]);
  }, [executeWhileLoading, fetchMatches, updateProfile, showMessage]);
  (0, _react.useEffect)(function () {
    if (isAuthenticated && !loaded) {
      fetchProfile().then(function (profile) {
        setProfileState(typeof profile.active === 'undefined' ? true : profile.active);
      });
    }
  }, [isAuthenticated, fetchProfile, loaded]);

  var logOut = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var PcAuth;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return loadAuth();

            case 2:
              PcAuth = _context.sent;
              PcAuth.signOut().then(function () {
                window && window.open('/', '_self');
              }).catch(function (err) {
                return console.error('SignOutErr', err);
              });

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function logOut() {
      return _ref2.apply(this, arguments);
    };
  }();

  var onSubmit = function onSubmit(data) {
    var submitData = data;

    if (submitData.password !== '' && submitData.passwordNew !== '') {
      formMethods.clearErrors('passwordEmpty');
      updatePassword(submitData.password, submitData.passwordNew);
    }

    if (submitData.password !== '' && submitData.passwordNew === '' || submitData.password === '' && submitData.passwordNew !== '') {
      return formMethods.setError('passwordEmpty', {
        type: 'onSubmit',
        message: t("".concat(translateNs, ".Validation.Error.passwordEmpty"))
      });
    }
    /* 
      remove password fields 
      from submitData object
    */


    delete submitData.password;
    delete submitData.passwordNew;
    delete submitData.email;

    if (!submitData.salutation) {
      delete submitData.salutation;
    } // remove whitespaces and unnecesery symbols and 0 from phoneNr


    submitData.phone_number = (0, _validators.telNummerCleaning)(submitData.phone_number);
    submitData['custom:locale'] = activeLang;
    updateUserData(submitData);
  };

  var updateUserData = /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(userAttributes) {
      var localeReload,
          currentUserData,
          PcAuth,
          _args2 = arguments;
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              localeReload = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : false;
              currentUserData = user.attributes;

              if (!(currentUserData.gender !== userAttributes.gender || currentUserData.name !== userAttributes.name || currentUserData.phone_number !== userAttributes.phone_number)) {
                _context2.next = 7;
                break;
              }

              _context2.next = 5;
              return loadAuth();

            case 5:
              PcAuth = _context2.sent;
              PcAuth.updateUserAttributes(user, userAttributes).then(function () {
                fetchUserData(true);
                showMessage('success', 'data', 'Success'); // setCurrentUser()

                if (localeReload) {
                  setTimeout(function () {
                    window.location.href = "/".concat((0, _translatedPaths.default)('pcMatchingSettings', userAttributes['custom:locale'] || 'de'));
                  }, 1000);
                }
              }).catch(function (err) {
                if (err.code === 'AliasExistsException') {
                  showMessage('warning', 'email', 'Error');
                }

                if (err.message === 'Invalid phone number format.') {
                  showMessage('warning', 'phone', 'Error');
                }
              });

            case 7:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function updateUserData(_x) {
      return _ref3.apply(this, arguments);
    };
  }();
  /**
   * updates the old user password with
   * the new password in cognito
   */


  var updatePassword = /*#__PURE__*/function () {
    var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(password, passwordNew) {
      var _yield$import, PcAuth;

      return _regenerator.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return import('@jobmatchme/amplify-tools/es/auth/Pc');

            case 2:
              _yield$import = _context3.sent;
              PcAuth = _yield$import.PcAuth;
              PcAuth.changePassword(user, password, passwordNew).then(function () {
                // set password fields to empty string
                formMethods.setValue('password', '');
                formMethods.setValue('passwordNew', '');
                showMessage('success', 'password', 'Success');
                setShowPasswordDefault(false);
              }).catch(function (error) {
                error.code === 'LimitExceededException' ? showMessage('warning', 'default', 'Error') : showMessage('warning', 'password', 'Error');
                setShowPasswordDefault(true);
              });

            case 5:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function updatePassword(_x2, _x3) {
      return _ref4.apply(this, arguments);
    };
  }();

  var handleProfileState = function handleProfileState(value) {
    if (profileState !== value) {
      setProfileState(value);
      updateProfileState(value).then(function () {
        (0, _trackingService.trackEvent)({
          eventName: 'profileStateChanged',
          pcUuid: user.username,
          payload: {
            active: value
          }
        }); // Send confirmation Email

        if (!value) {
          actions.sendDeactivatedProfileEmail(user.attributes.email.toLowerCase()).then(function (res) {
            if (res) {
              showMessage('success', 'profileNotActive', 'Success');
            }
          });
        } else {
          showMessage('success', 'profileActive', 'Success');
        }
      });
    }
  };

  var _useState11 = (0, _react.useState)(false),
      _useState12 = (0, _slicedToArray2.default)(_useState11, 2),
      openConfirmationDialog = _useState12[0],
      setConfirmationDialog = _useState12[1];

  var handleClickOpen = function handleClickOpen() {
    setConfirmationDialog(true);
  };

  var handleClose = function handleClose() {
    setConfirmationDialog(false);
  };

  var handleLanguageChange = function handleLanguageChange(value) {
    setActiveLang(value);
    setLangTouched(true);
  };

  var handleLangSubmit = function handleLangSubmit() {
    updateUserData({
      'custom:locale': activeLang
    }, true);
    setLangTouched(false);
  };

  var DialogActions = function DialogActions() {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Grid.default, {
      container: true,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid.default, {
        item: true,
        xs: 6,
        alignContent: "center",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
          texttransform: "none",
          className: _styleModule.default.deactivateBtn,
          onClick: function onClick() {
            handleProfileState(false);
            handleClose();
            showQuestionByDeactivation();
          },
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            children: t("".concat(translateNs, ".confirmationDialog.deactivateBtn"))
          })
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid.default, {
        item: true,
        xs: 6,
        alignContent: "center",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
          color: "primary",
          variant: "contained",
          round: true,
          flat: true,
          texttransform: "none",
          className: _styleModule.default.cancelBtn,
          onClick: function onClick() {
            handleProfileState(true);
            handleClose();
          },
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            children: t("".concat(translateNs, ".confirmationDialog.cancelBtn"))
          })
        })
      })]
    });
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactHookForm.FormProvider, (0, _extends2.default)({}, formMethods, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("form", {
        onSubmit: formMethods.handleSubmit(onSubmit),
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Box.default, {
          className: "".concat(_styleModule.default.container),
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_VerticalChange.default, {
            current: vertical
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
            className: _styleModule.default.searchSettings,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Edit.default, {
              config: profileConfig,
              profile: context,
              onPropertySave: onProfileUpdate,
              showLoader: !loaded
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Headline.default, {
            center: false,
            text: t("".concat(translateNs, ".headline"))
          }, "headline1"), /*#__PURE__*/(0, _jsxRuntime.jsx)(_EditUser.default, {
            user: {
              salutation: typeof user.attributes.gender !== 'undefined' ? user.attributes.gender : '',
              name: typeof user.attributes.name !== 'undefined' ? user.attributes.name : '',
              email: user.attributes.email,
              phone_number: user.attributes.phone_number
            },
            emailDisplayOnly: true,
            t: t,
            errorStyle: _styleModule.default.error
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ChangePassword.default, {
            t: t,
            showPasswordDefault: showPasswordDefault,
            errorStyle: _styleModule.default.error
          }), formMethods.formState.isDirty && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
            color: "primary",
            variant: "contained",
            round: true,
            flat: true,
            extraBold: true,
            texttransform: "none",
            className: _styleModule.default.saveBtn,
            type: "submit",
            children: t("".concat(translateNs, ".saveBtn"))
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("br", {}), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Box.default, {
            className: _styleModule.default.languageSection,
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Headline.default, {
              center: false,
              text: t("".concat(translateNs, ".languageSection.headline"))
            }, "headline1"), /*#__PURE__*/(0, _jsxRuntime.jsx)("br", {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Flags.default, {
              activeLang: activeLang,
              handleChange: handleLanguageChange
            })]
          }), langTouched && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
            color: "primary",
            variant: "contained",
            round: true,
            flat: true,
            extraBold: true,
            texttransform: "none",
            className: _styleModule.default.saveBtn,
            type: "button",
            onClick: handleLangSubmit,
            children: t("".concat(translateNs, ".languageSection.saveBtnLang"))
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_AccountVerification.default, {}), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Box.default, {
            className: _styleModule.default.accountSettings,
            children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_Box.default, {
              className: _styleModule.default.switcherWrapper,
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_FormControlLabel.default, {
                className: _styleModule.default.checkBox,
                value: "start",
                control: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Switcher.default, {
                  checked: profileState,
                  handleChange: function handleChange() {
                    profileState ? handleClickOpen() : handleProfileState(true);
                  }
                }),
                label: /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {}),
                labelPlacement: "start"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                className: _styleModule.default.switcherLaber,
                children: profileState ? t("".concat(translateNs, ".setProfileStatus.statusActive")) : t("".concat(translateNs, ".setProfileStatus.statusInactive"))
              })]
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
              className: _styleModule.default.separator
            }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Button.default, {
              texttransform: "none",
              className: _styleModule.default.logOutButton,
              onClick: logOut,
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_PowerSettingsNew.default, {
                className: _styleModule.default.buttonIcon
              }), ' ', /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                children: t("".concat(translateNs, ".logOut"))
              })]
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ModalDialog.default, {
              id: 'confirmationDialog',
              title: t("".concat(translateNs, ".confirmationDialog.title")),
              showDividers: false,
              verticalMobilePosition: 'bottom',
              opacity: 0.5,
              open: openConfirmationDialog,
              onClose: handleClose,
              dialogActions: /*#__PURE__*/(0, _jsxRuntime.jsx)(DialogActions, {}),
              children: t("".concat(translateNs, ".confirmationDialog.description"))
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_DeactivationQuestion.default, {
              t: t,
              translateNs: translateNs,
              openDialog: openQuestionDialog,
              closeForm: closeForm
            })]
          })]
        })
      })
    }))
  });
};

var _default = (0, _notistack.withSnackbar)(ProfileForm);

exports.default = _default;